const BASE = "/api";

async function request(path, options = {}) {
  const res = await fetch(BASE + path, {
    headers: { "Content-Type": "application/json", ...options.headers },
    ...options,
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Request failed");
  return data;
}

export const api = {
  // AORs
  getAORs: () => request("/aors"),
  getAOR: (id) => request("/aors/" + id),
  createAOR: (data) => request("/aors", { method: "POST", body: JSON.stringify(data) }),
  updateAOR: (id, data) => request("/aors/" + id, { method: "PUT", body: JSON.stringify(data) }),
  submitAOR: (id) => request("/aors/" + id + "/submit", { method: "POST" }),

  // Vendor Evaluations
  getVendorEvaluations: () => request("/vendor-evaluations"),
  getVendorEvaluation: (id) => request("/vendor-evaluations/" + id),
  createVendorEvaluation: (data) => request("/vendor-evaluations", { method: "POST", body: JSON.stringify(data) }),
  updateVendorEvaluation: (id, data) => request("/vendor-evaluations/" + id, { method: "PUT", body: JSON.stringify(data) }),
  submitVendorEvaluation: (id) => request("/vendor-evaluations/" + id + "/submit", { method: "POST" }),
  getPendingEvaluations: () => request("/vendor-evaluations/evaluations/pending"),
  submitEvaluation: (id, data) => request("/vendor-evaluations/" + id + "/evaluate", { method: "POST", body: JSON.stringify(data) }),
  awardEvaluation: (id, data) => request("/vendor-evaluations/" + id + "/award", { method: "POST", body: JSON.stringify(data) }),
  convertEvaluationToPO: (id) => request("/vendor-evaluations/" + id + "/convert", { method: "POST" }),

  // Tender Requests
  getTenderRequests: () => request("/tender-requests"),
  getTenderRequest: (id) => request("/tender-requests/" + id),
  getTenderClosingDate: (type, start) => request("/tender-requests/closing-date?type=" + encodeURIComponent(type) + "&start=" + encodeURIComponent(start)),
  createTenderRequest: (data) => request("/tender-requests", { method: "POST", body: JSON.stringify(data) }),
  updateTenderRequest: (id, data) => request("/tender-requests/" + id, { method: "PUT", body: JSON.stringify(data) }),
  submitTenderRequest: (id) => request("/tender-requests/" + id + "/submit", { method: "POST" }),
  postTenderRequest: (id) => request("/tender-requests/" + id + "/post", { method: "POST" }),
  cancelTenderRequest: (id) => request("/tender-requests/" + id + "/cancel", { method: "POST" }),

  // Approvals
  getPending: () => request("/approvals/pending"),
  getHistory: () => request("/approvals/history"),
  approve: (id, data) => request("/approvals/" + id + "/approve", { method: "POST", body: JSON.stringify(data) }),
  reject: (id, data) => request("/approvals/" + id + "/reject", { method: "POST", body: JSON.stringify(data) }),

  // Xero
  xeroStatus: () => request("/xero/status"),
  xeroConnect: () => request("/xero/connect"),
  xeroDisconnect: () => request("/xero/disconnect", { method: "POST" }),
  xeroAccounts: () => request("/xero/accounts"),
  xeroBankAccounts: () => request("/xero/bank-accounts"),
  pushInvoiceToXero: (id) => request("/invoices/" + id + "/push-xero", { method: "POST" }),

  // Payment runs
  getPaymentBatches: (status) => request("/payments/batches" + (status ? "?status=" + encodeURIComponent(status) : "")),
  getPaymentBatch: (id) => request("/payments/batches/" + id),
  getEligibleInvoices: (tier) => request("/payments/eligible?tier=" + tier),
  createPaymentBatch: (data) => request("/payments/batches", { method: "POST", body: JSON.stringify(data) }),
  requestPaymentOverride: (id, reason) => request("/payments/batches/" + id + "/override-request", { method: "POST", body: JSON.stringify({ reason }) }),
  grantPaymentOverride: (id, data) => request("/payments/batches/" + id + "/override-grant", { method: "POST", body: JSON.stringify(data) }),
  editPaymentBatchItems: (id, data) => request("/payments/batches/" + id + "/items", { method: "PATCH", body: JSON.stringify(data) }),
  submitPaymentBatch: (id) => request("/payments/batches/" + id + "/submit", { method: "POST" }),
  cancelPaymentBatch: (id) => request("/payments/batches/" + id + "/cancel", { method: "POST" }),
  executePaymentBatch: (id) => request("/payments/batches/" + id + "/execute", { method: "POST" }),
  getPaymentBankFile: (id) => request("/payments/batches/" + id + "/bank-file"),

  // Reference data / policy
  getReferenceLookup: (type) => request("/reference/" + type),
  getProcurementPolicy: () => request("/reference/policy/procurement"),

  // Health
  health: () => request("/health"),
};